import { ModuleBase } from "@/modules/base";
import { Component, Mixins } from 'vue-property-decorator';
import { Params, defaultParams } from '../SspDataModule';
import AnalysisMenu from './AnalysisMenu.vue';
import BaseLayer from "./BaseLayer.vue";
import OverlayLayer from './OverlayLayer.vue';
import Window from './Window.vue';
import { ExternalTileDataDef, routerSync } from '@/vue/router';
import axios from 'axios'


export interface ExternalTileData {
  show: boolean
  showParamsWindow: boolean
  baseUrl: string
  colorParams: Params
  filters: string[]
  areas: { [filter: string]: [number, number, number][][] }
}


@Component
export class ExternalTileDataModule extends Mixins(ModuleBase) {
  entries: ExternalTileData[] = []

  get outlet() {
    return {
      window: Window,
      analysisMenu: AnalysisMenu,
      baseLayer: BaseLayer,
      overlayLayer: OverlayLayer,
    }
  }

  add(def: ExternalTileDataDef) {
    let { baseUrl, colorParams } = def
    baseUrl = baseUrl.replace(/(.*?)\/?$/, '$1')
    const t: ExternalTileData = {
      baseUrl,
      show: true,
      colorParams: colorParams || defaultParams(),
      filters: [],
      areas: {},
      showParamsWindow: true,
    }
    this.entries.push(t)
    axios.get<string[]>(`${baseUrl}/filter.json`).then(({ data: filters }) => {
      t.filters = filters
    })
    axios.get<AreaFileType>(`${baseUrl}/area.json`).then(({ data: areas }) => {
      if (Array.isArray(areas)) {
        areas = { $any: areas }
      }
      for (const k in areas) {
        Object.freeze(areas[k])
      }
      t.areas = areas
    })
    routerSync()
  }
}

export type AreaType = [number, number, number][][]

type AreaFileType = AreaType | { [filter: string]: AreaType }
